// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Партійна робота» (Party work, ключ `pwork`, група `party-and-group`). */
export const partyWorkManifest: IModuleManifest = {
  key: 'pwork',
  group: 'party-and-group',
  slug: 'party-work',
  prefix: 'PTW',
  name: { en: 'Party work', uk: 'Партійна робота' },
  entities: [
    { key: 'pwork', slug: 'pwork', name: { en: 'Party tasks', uk: 'Завдання партії' }, main: true },
    { key: 'pdoc', slug: 'pdoc', name: { en: 'Document reviews', uk: 'Ознайомлення з документами' }, main: false },
    { key: 'pdisc', slug: 'pdisc', name: { en: 'Internal discussions', uk: 'Внутрішні обговорення' }, main: false },
  ],
  loadState: () => import('./state/partyWorkSlice').then((m) => m.partyWorkSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
